
import {db, tables} from '../database';
import Message from '../components/Message';
import Spinner from '../components/Spinner';

import WindowStateBar from './WindowStateBar.vue';

import {useRoute, useRouter} from 'vue-router';
import {nextTick, reactive, ref, defineComponent} from 'vue';
import {login as loginApi, logout as logoutApi} from '../api';

import {User} from 'src/types';

export default defineComponent({
  name: 'TitleBar',

  components: {WindowStateBar},

  setup() {
    const backLength = ref(0);
    const forwardLength = ref(0);
    const searchInput = ref('');
    const loginModal = ref(false);

    // 用户基本信息
    const user = reactive<User>({} as User);

    const router = useRouter(), route = useRoute();

    let navigation: boolean | null = null;

    router.afterEach((/*to, from*/) => {
      if (!navigation) {
        navigation = true;
        return;
      }

      if (backLength.value === 0) {
        forwardLength.value = 0;
        // const {electron: electronApi} = window as any;
        // electronApi ? electronApi.clearHistory() : null;
      }
      ++backLength.value;
    });

    /**
     * 开始登录
     *
     * @param event 点击事件,若事件为不存在,则认为主动调用
     */
    const login = async (event: PointerEvent | void) => {
      Spinner.open();

      try {
        /** @type {Electron.Cookie[]} */
        let cookies, uin;

        if (event) {
          const data = await loginApi(null);
          const {option} = data || {};

          if (!option || !option.url) {
            return Message.error('登录失败！');
          }

          const {electron: electronApi} = window as any;
          cookies = electronApi && JSON.parse(await electronApi.openModal(option));

          if (!cookies || cookies.length < 1) {
            return Message.info('已取消登录！');
          }

        } else {
          // 从数据库获取用户信息
          await db.open();
          const usersInfo = await db.queryAll(tables.user);
          const [{uin: _uin = '', cookies: cookieArray = []} = {}] = usersInfo || [];

          uin = _uin;
          cookies = _uin && cookieArray;

          if (!cookies || cookies.length < 1) {
            // 中断且不提示任何消息
            return;
          }
        }

        const data = await loginApi(cookies);
        const {user: userInfo, reason} = data;

        if (!userInfo || !userInfo.uin) {
          // 若网络连接正常情况下, 仍然登录失败, 则删除已存储的用户信息
          if (navigator.onLine) {
            // 删除indexDB中存储的用户信息
            await db.delete(tables.user, uin);
          }

          return Message.error(reason || '未知错误！');
        }

        // 删除indexDB中存储的用户信息
        await db.delete(tables.user, userInfo.uin);
        // 添加新的用户信息到indexDB中
        await db.insert(tables.user, userInfo);
        // 将新的用户信息复制到视图展示的user对象上
        Object.assign(user, userInfo);

      } catch (e: any) {
        Message.error(`登录失败： ${e.message} !`);
      } finally {
        Spinner.close();
      }
    };

    // 尝试登录
    nextTick(login);

    return {
      loginModal, backLength, forwardLength, searchInput, user,

      /** 后退 */
      back() {
        if (backLength.value) {
          navigation = false;
          router.back();
          ++forwardLength.value;
          --backLength.value;
        }
      },

      /** 前进 */
      forward() {
        if (forwardLength.value) {
          navigation = false;
          router.forward();
          --forwardLength.value;
          ++backLength.value;
        }
      },

      /** 刷新 */
      refresh() {
        location.reload();
      },

      login,

      /** 退出登录 */
      logout() {
        if (user.uin) {
          // 删除indexDB中存储的用户信息
          db.delete(tables.user, user.uin).then(logoutApi).then(data => {
            if (data && data.cookieURL) {
              const {electron: electronApi} = window as any;
              electronApi.removeAllCookie(data.cookieURL);
            }
          });
        }
      },

      /** 打开资源搜索页面 */
      openNetSearchView() {
        const value = searchInput.value;

        if (value) {
          const viewPath = '/net-search-view', {path, query} = route;

          // 若当前路径相同且查询参数相同, 则什么也不做; 否则则跳转到搜索页面
          if ((path !== viewPath || query.value !== value)) {
            router.push({path: viewPath, query: {value}});
          }
        }
      },

      openSystemSetting() {
        const viewPath = '/system-setting', path = route.path;

        if (path !== viewPath) {
          router.push({path: viewPath});
        }
      }
    };
  }

});
